// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1214":"f1e944ca78c22ab7","2311":"18bf93f3b967cc2d"}[chunkId] + ".js";
};